import { total, balanceOutstanding } from "./invoice.js";
import store from "../store/index.js";
let events = () => {
  return store.getters.events();
};

let unsignedEvents = () => {
  return events().filter((event) => {
    if (event.contracts) {
      if (Array.isArray(event.contracts)) {
        return (
          event.contracts.filter((contract) => {
            return !contract.signerDate;
          }).length > 0
        );
      } else {
        return false;
      }
    }
  });
};
let delinquentEvents = () => {
  let finalPaymentSettings = store.getters.finalPaymentSettings;
  let depositAmount = (event) => {
    if (store.getters.depositType === "percentage") {
      return parseInt(store.getters.depositAmount) * 0.01 * total(event);
    } else {
      return parseInt(store.getters.depositAmount) * 100;
    }
  };
  let depositsUnpaid = () => {
    return events().filter((x) => {
      return (
        total(x) - balanceOutstanding(x) < depositAmount(x) &&
        balanceOutstanding(x) > 0
      );
    });
  };
  let finalPaymentsUnpaid = () => {
    let finalPaymentDueDate = (event) => {
      let date;
      switch (event.api_version) {
        case "9-28-2022":
          date = event.date;
          break;
        default:
          date = event.data.date;
          break;
      }
      date = new Date(date);
      if (finalPaymentSettings.type === "weeks") {
        return new Date(
          date.setDate(date.getDate() - finalPaymentSettings.increment * 7)
        );
      } else if (finalPaymentSettings.type === "months") {
        return new Date(
          date.setMonth(date.getMonth() - finalPaymentSettings.increment)
        );
      } else if (finalPaymentSettings.type === "days") {
        return new Date(
          date.setDate(
            date.setDate(date.getDate() - finalPaymentSettings.increment)
          )
        );
      } else {
        return date;
      }
    };
    return events().filter((x) => {
      return balanceOutstanding(x) > 50 && finalPaymentDueDate(x) < new Date();
    });
  };
  let eventsArr = new Set([...depositsUnpaid(), ...finalPaymentsUnpaid()]);
  return Array.from(eventsArr).sort((a, b) => {
    let startTime = (event) => {
      switch (event.api_version) {
        case "9-28-2022":
          return new Date(event.start_time).getTime();
        default:
          return new Date(event.data.startTime).getTime();
      }
    };
    let aStart = startTime(a);
    let bStart = startTime(b);
    return aStart < bStart ? -1 : aStart > bStart ? 1 : 0;
  });
};

export { delinquentEvents, unsignedEvents };
